import { Skeleton } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { colorsV2 } from '../../colors-v2';

const Main = styled.div`
  border-radius: 16px;
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 1fr) max-content;
  padding: 24px;
  border: 1px solid ${colorsV2.gray50};
  .image {
    .ant-skeleton-image {
      width: 216px;
      height: 144px;
      border-radius: 16px;
    }
  }
  &.reverse {
    grid-template-columns: max-content minmax(0, 1fr);
    .image {
      order: -1;
    }
  }
`;

interface CardPlaceholderProps {
  reverse?: boolean;
}

export const CardPlaceholder = React.memo(({ reverse }: CardPlaceholderProps) => (
  <Main className={cl({ reverse })}>
    <Skeleton active />
    <div className="image">
      <Skeleton.Image />
    </div>
  </Main>
));
